import gql from 'graphql-tag';

export default gql`
  fragment AuthUserFragment on User {
    is_guest
    token
    full_name
    gender
    dob
    subscribed_to_cashback
    interests {
      id
      name
      name_ar
    }
    phone_number {
      number
    }
    email
    first_auth_signup
    country {
      id
      name
      iso_code
    }
    wallet {
      id
      number
      authorized_balance
      currency {
        code
      }
      authorized_financial_transaction_amounts {
        amount
        created_at
        credit_amount
        description
        currency {
          code
        }
      }
      on_hold_financial_transaction_amounts {
        amount
        created_at
        credit_amount
        description
        currency {
          code
        }
      }
    }
    wallet_balance
    total_orders
    is_reseller
    wrapper {
      id
      number
    }
    phone_number {
      number
    }
    addresses {
      id
      street_number
      apartment_floor
      full_name
      city {
        id
        name
        country {
          name
        }
      }
      phone_number {
        intl_number
      }
    }
    isBusiness
    businessExpiryDate
    businessPricing {
      deliveryFee
      kgRate
      feesPercentage
      feesConstant
      vatPercentage
      subscriptionFee
      planFid
      expressConstant
    }
    canUseOldCart
    newCartExperience
  }
`;



// WEBPACK FOOTER //
// ./app/containers/Auth/graphql/userFragment.gql.js